import axios from "axios";

// Backend base URL - Using environment variables from root .env
const BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://glucera1api.universal-software.in/api";
const TENANT_ID = import.meta.env.VITE_X_TENANTID || "ab9bb443-b2ef-4b55-b0ed-0b4a41bb2dc8";

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "X-Tenant-ID": TENANT_ID,
  },
});

// Request interceptor - Add auth token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only add X-User-Timezone if not already set on this request
    if (!config.headers["X-User-Timezone"]) {
      config.headers["X-User-Timezone"] =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    console.log("🚀 API Request:", config.method?.toUpperCase(), config.url, "Params:", config.params);
    return config;
  },
  (error) => {
    console.error("❌ API Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor - Handle common errors
apiClient.interceptors.response.use(
  (response) => {
    console.log("✅ API Response:", response.config.url, "Status:", response.status);
    return response;
  },
  (error) => {
    console.error("❌ API Response Error:", error.config?.url, error.response?.status, error.message);
    if (error.response?.status === 401) {
      // Handle unauthorized - redirect to login
      localStorage.removeItem("authToken");
      window.location.href = "/bite-balance/admin/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
